import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommandFactory } from "./action-command-factory";
import { ActionCommand } from "./action-command-interface";

export class CommandExecutor {
  private factory: ActionCommandFactory;

  constructor(renderEngineComponent: any) {
    this.factory = new ActionCommandFactory(renderEngineComponent);
  }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    const command:ActionCommand = this.factory.createCommand(actionData.type);
    return command.execute(actionData, requestData);
  }
}